import styles from "./index.module.less";
// import InfiniteScroll from "react-infinite-scroll-component";
import useAppStore from "@/context/store";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import HBLoading from "../HBLoading";
import InfiniteScroll from "../InfiniteScroll";
import LoginDialog, { useLogin } from "../LoginModal";
import { useLoadingLimit } from "../LoginModal/useLoginLimit";
import Masonry from "../Masonry";
/**
 * @param {{
 *   disableMasonry?: boolean;
 *   dataSource: any[];
 *   render: (record: any, index: number) => any;
 *   onLoadMore?: (record: any) => any;
 *   children?: any;
 *   hasMore?: boolean;
 *   scrollableTarget?: any;
 *   endMessage?: any;
 *   infiniteScrollOptions?: any;
 *   masonryOptions?: any;
 *   uniqueKey: string;
 *   loginGuide?: boolean;
 *   masonryRef?: any;
 *   listStyle?: any;
 *   filter?: any;
 *   className?: string;
 *   scrollThreshold?: string | number;
 * }} query
 * @returns {any}
 */
export default function HBList({
  disableMasonry,
  dataSource = [],
  render,
  onLoadMore,
  children,
  hasMore = true,
  scrollableTarget,
  endMessage,
  infiniteScrollOptions,
  masonryOptions,
  uniqueKey,
  loginGuide,
  masonryRef,
  listStyle = {},
  filter = null,
  className = "",
  loadingContent = null,
  firstLoadingContent = null,
  scrollThreshold = "800px",
  pageSize,
}) {
  const { login } = useLogin();
  const listRef = useRef(null);
  const [dataLength, setDataLength] = useState(dataSource.length);

  const newDataSource = useMemo(() => {
    if (filter) {
      return filter(dataSource);
    }
    return dataSource;
  }, [dataSource, filter]);

  const renderList = useMemo(() => {
    const list = [];

    let index = 0;
    newDataSource.reduce((map, record) => {
      if (uniqueKey) {
        if (!map[record[uniqueKey]]) {
          list.push(render(record, index++));
          map[record[uniqueKey]] = true;
        }
      } else {
        list.push(render(record, index++));
      }

      return map;
    }, {});

    if (children) {
      list.unshift(children);
    }

    return list;
  }, [children, newDataSource, uniqueKey, render]);

  // useEffect(() => {
  //   if (dataSource.length > 0) {
  //     if (scrollableTarget) {
  //       const target =
  //         typeof scrollableTarget === "string"
  //           ? document.getElementById(scrollableTarget)
  //           : scrollableTarget;
  //       listRef.current.throttledOnScrollListener({ target });
  //     } else {
  //       listRef.current.throttledOnScrollListener();
  //     }
  //   }
  // }, [dataSource, scrollableTarget]);
  const { user, userReady } = useAppStore(({ user, userReady }) => ({
    user,
    userReady,
  }));

  const endMsg = useMemo(() => {
    if (endMessage === undefined) {
      if (loginGuide && userReady && !user) {
        return (
          <div
            className={styles.endMessage}
            data-gd-click="button_click"
            data-button-name="注册或登录"
            data-content-source="底部栏"
          >
            <span onClick={() => login({ target: "blank" })}>注册或登录</span>
            可查看更多优质内容哦~
          </div>
        );
      }
      return (
        <p
          data-gd-expose="resource_loc_expose"
          data-resource-title="没有更多了"
          data-resource-type="文字"
          className={classNames([styles.noMore, "noMore"])}
        >
          没有更多了
        </p>
      );
    } else {
      return endMessage;
    }
  }, [endMessage, loginGuide, user, userReady, login]);

  // 登录访问限制
  const {
    limit: loginLimit,
    config: limitConfig,
    allLimit,
  } = useLoadingLimit({
    pageListData: dataSource,
    ignore: !loginGuide,
    pageSize: pageSize,
  });

  useEffect(() => {
    if (loginLimit) {
      const closable = limitConfig?.closable || !allLimit;
      LoginDialog.open({
        closable: closable,
        maskClosable: closable,
        keyboard: closable,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginLimit]);

  const changeDataLength = useMemoizedFn(() => {
    setDataLength(dataSource.length);
  });

  const loaderContent = useMemo(() => {
    // 首屏loading内容加载
    if (dataSource.length === 0 && firstLoadingContent && !children) {
      return firstLoadingContent;
    }

    return (
      loadingContent ?? (
        <div className={classNames([styles.loading, "loading"])}>
          <HBLoading size="30px" />
        </div>
      )
    );
  }, [children, dataSource.length, firstLoadingContent, loadingContent]);

  return (
    <InfiniteScroll
      dataLength={disableMasonry ? dataSource.length : dataLength}
      hasMore={hasMore && !loginLimit}
      next={onLoadMore}
      className={className}
      loader={loaderContent}
      endMessage={endMsg}
      ref={listRef}
      {...(scrollableTarget ? { scrollableTarget } : null)}
      {...infiniteScrollOptions}
      scrollThreshold={scrollThreshold}
    >
      <If condition={!disableMasonry}>
        <Then>
          <Masonry
            bricks={newDataSource}
            brickId={uniqueKey}
            render={render}
            ref={masonryRef}
            onRendered={changeDataLength}
            loadingContent={firstLoadingContent}
            {...masonryOptions}
            {...(scrollableTarget ? { scrollElement: scrollableTarget } : null)}
          >
            {children}
          </Masonry>
        </Then>
        <Else>
          <div className={styles.list} style={listStyle}>
            {renderList}
          </div>
        </Else>
      </If>
    </InfiniteScroll>
  );
}
